import PanelcommissionAdm from '../panelcommissionAdm/panelcommissionAdm.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import SalesinformationAdm from '../salesinformationAdm/salesinformationAdm.vue'
import CommissionformAdm from '../commissionformAdm/commissionformAdm.vue'

const Tabs = {
  Detalhes: 0,
  valor: 1,
  comissao: 2
}

export default {
  components: {SalesinformationAdm, CommissionformAdm, PanelcommissionAdm},
  name: 'CommissiondetailsAdm',
  mixins: [ActionsForm],
  props: ['dataDetails'],
  data () {
    return {
      headTable: ['Valor de parcela', 'Vencimento', 'status'],
      tabIndex: Tabs.Detalhes
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissions/components/CommissionDetailsAdm/CommissionDetailsAdm.js